import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link, useHref, useLocation, useNavigate, } from 'react-router-dom';
import { Box, Dialog, DialogContent, DialogTitle, Typography, Alert, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import AuthGuard from '../auth/AuthGuard';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
const limitToPageWidth = true;
const Header = () => (_jsxs(Typography, { variant: "h5", sx: { p: 3 }, children: ["To start the checkout process,", ' ', _jsx("b", { children: "Create an Account" }), ", or if you already have an account, click the", ' ', _jsx("b", { children: "Sign In" }), ' ', "tab below."] }));
/**
 * Checkout Widget.  Items in cart are in the query params.
 */
const Checkout = ({ checkoutTypes, checkoutIDs, editData, }) => {
    const store = useStore();
    const { currentCustomer } = useStore();
    const location = useLocation();
    const navigate = useNavigate();
    // const { currentCustomer } = store;
    const cancelUrl = useHref(location.state?.from?.location?.pathname || '/');
    const [member, setMember] = useState();
    const [errorMessage, setErrorMessage] = useState(null);
    const [richTextError, setRichTextError] = useState(null);
    // Parse checkout types and IDs from URL query parameters
    const searchParams = new URLSearchParams(location.search);
    const typesFromUrl = searchParams.get('type');
    const idsFromUrl = searchParams.get('id');
    // Use URL parameters if available, otherwise fall back to props
    const effectiveCheckoutTypes = typesFromUrl || checkoutTypes;
    const effectiveCheckoutIDs = idsFromUrl || checkoutIDs;
    const parsedErrorMessage = (() => {
        if (!richTextError)
            return null;
        try {
            const parsed = JSON.parse(richTextError);
            if (parsed?.slate) {
                return parsed;
            }
        }
        catch (e) {
            console.log('Failed to parse rich text error message.');
        }
        return null;
    })();
    useEffect(() => {
        const startCheckout = async () => {
            const ids = effectiveCheckoutIDs.split(',');
            const types = effectiveCheckoutTypes.split(',');
            if (ids.length !== types.length) {
                throw Error('types and ids list must have same number of elements');
            }
            const items = ids.map((id, index) => ({
                type: types[index],
                id,
            }));
            // console.log('Calling checkout', items);
            // setBlockInput(true);
            const response = await store.startCheckout(items, cancelUrl);
            // setBlockInput(false);
            // console.log('checkout response', response);
            // Do the checkout
            if (response.statusCode === 200 && response.checkoutUrl) {
                console.log('Redirecting to stripe for checkout');
                window.location.replace(response.checkoutUrl);
            }
            if (response.statusCode === 201) {
                console.log('Free membership, show details');
                console.log('Setting member', response);
                setMember(response.member);
                navigate(`./confirm?memberID=${response.member.id}`);
            }
            if (response.statusCode === 202) {
                console.log('Already a member, show details');
                setMember(response.member);
            }
            if (response.statusCode >= 400) {
                console.error('Error initiating checkout', response);
                if (response.richText) {
                    setRichTextError(response.richText);
                }
                else {
                    setErrorMessage(response.message || 'An error occurred during the checkout process. Please try again later.');
                }
            }
        };
        console.log('useEffect', store.currentCustomer);
        if (member) {
            // nothing to do here
            return;
        }
        if (editData) {
            // dont do check out in design mode
            return;
        }
        if (currentCustomer) {
            startCheckout().then(() => console.log('start done'));
        }
    }, [
        store,
        effectiveCheckoutTypes, effectiveCheckoutIDs, currentCustomer,
        member, navigate,
        cancelUrl, editData,
    ]);
    // if (blockInput) {
    //   navStore.showBlockInput();
    // } else {
    //   navStore.clearBlockInput();
    // }
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: _jsx(AuthGuard, { initialTab: "SIGN-UP", header: _jsx(Header, {}), children: _jsxs(Box, { sx: {
                    minHeight: 200,
                }, children: [(errorMessage || parsedErrorMessage) && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: typeof parsedErrorMessage === 'object' && parsedErrorMessage?.slate ? (_jsx(WysiwygViewer, { id: "emailDomainMismatchError", value: parsedErrorMessage.slate })) : (_jsx(Typography, { variant: "body1", children: errorMessage })) })), member ? (_jsxs(Dialog, { open: true, children: [_jsx(DialogTitle, { children: "Already Purchased Membership" }), _jsx(DialogContent, { children: _jsxs(Typography, { variant: "h4", children: ["This course or program is included in a membership that you already have.", _jsx(Link, { to: "/", children: "Click here" }), ' ', "to return to the home page and attempt to access the desired course."] }) })] })) : (_jsx(Box, { children: editData && (_jsx("div", { children: "Redirect to Checkout" })
                        /* <Typography variant="h3">
                        Redirecting to checkout.
                        </Typography>
                        <Link to={window.location}>
                          Click here if not redirected.
                        </Link> */
                        ) }))] }) }) }));
};
Checkout.defaultProps = {};
Checkout.meta = {
    group: 'commerce',
    name: 'Checkout Initiator',
    description: 'Initiates Checkout Session for specificed course, program or membership.',
    props: [
        {
            key: 'checkoutTypes',
            name: 'Checkout Types',
            type: 'array',
            description: 'An array of checkout types.',
        },
        {
            key: 'checkoutIDs',
            name: 'Checkout IDs',
            type: 'array',
            description: 'An array of checkout IDs in same order as the checkoutTypes.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Checkout',
        props: {
            checkoutTypes: '@checkoutTypes',
            checkoutIDs: '@checkoutIDs',
        },
    },
};
export default observer(Checkout);
//# sourceMappingURL=Checkout.js.map